export default __webpack_public_path__ + "static/hero-gateway-sm-38d3ac40a4d6a4902f3b24f1590ac8bf.png";